<template>
    <div class="flex flex-row">
        <component
            v-for="component in components"
            :key="component.sort"
            :is="component.component"
            v-bind="component.props"
        />
    </div>
</template>
<script lang="ts" setup>
    import Media from "@/components/Media.vue";
    import HeroText from "@/components/HeroText.vue";
    import { type Cta } from "@interfaces/Cta";
    import { computed, type PropType } from "vue";
    import { type MediaProps } from "@interfaces/MediaProps";

    interface HeroTextProps {
        eyebrow: string;
        header: string;
        body: string;
        cta: Cta;
        textAlignment: string;
        sort: number;
    }

    let { mediaProps, heroTextProps } = defineProps({
        mediaProps: {
            type: Object as PropType<MediaProps>,
            required: true
        },
        heroTextProps: {
            type: Object as PropType<HeroTextProps>,
            required: true
        }
    });

    let components = computed(() => {
        let mediaComponent = {
            component: Media,
            props: mediaProps,
            sort: mediaProps.sort
        };
        let heroTextComponent = {
            component: HeroText,
            props: heroTextProps,
            sort: heroTextProps.sort
        };

        return [mediaComponent, heroTextComponent].sort(
            (a, b) => a.sort - b.sort
        );
    });
</script>
